import React, { useState, useEffect, useRef } from "react";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import { useSelector } from "react-redux";
import NewProcessingModal from "../../../../components/LoadingModal/NewProcessingModal";
import TittleGeneratorTour from "../Tours/TittleGeneratorTour";

const TitleGeneratorHome = () => {
  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("");
  const [lastTitleNumber, setLastTitleNumber] = useState(0);
  const [titleNumberStart, setTitleNumberStart] = useState("");
  const [modalStatus, setModalStatus] = useState({ status: null, message: "" }); // "processing", "success", o null  
  const [showTour, setShowTour] = useState(false);
  const fileInputRef = useRef(null);

  const isSubmitDisabled = !file || !category || !titleNumberStart;
  const { user } = useSelector(({ authentication }) => authentication);

  useEffect(() => {
    const getLastTitle = async () => {
      let res = await CreacionTitulosService.getLastTitleNumber();
      setLastTitleNumber(res.data.lastTitleNumber);
    };
    getLastTitle();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handleNumberTitleChange = (e) => {
    setTitleNumberStart(e.target.value);
  };

  const resetFileInput = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const restartStates = () => {
    setTitleNumberStart("");
    setCategory("");
    resetFileInput();
    setLastTitleNumber(0);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }
    if (titleNumberStart <= lastTitleNumber) {
      alert("El número de inicio de los títulos es menor que el último título creado");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      setModalStatus({ status: "processing", message: "Procesando Excel..." });
      const response = await CreacionTitulosService.postGenerateTitles(file, category, user.dni, titleNumberStart);
      const blob = new Blob([response.data], { type: "application/zip" });
      setModalStatus({ status: "success", message: "Excel Procesado con éxito!!", time: 3000 });
      saveAs(blob, `${file.name.replace(/\.(xls|xlsx)$/, "")}_titulos.zip`);
      restartStates();
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      setModalStatus({ status: "error", message: "Error al procesar el excel", time: 3000 });
    }
  };

  return (
    <div className="shadow-top mt-5">
      <div className="p-4 shadow">
        <div className="d-flex">
          <h5 className="fw-semibold mb-4">Generador de Títulos</h5>

          <button className="btn-paso-paso" onClick={() => setShowTour(true)}>
            Guía paso a paso
          </button>
        </div>

        <div
          id="selecciona-categoria-titulo"
          className="mb-3 d-flex flex-column">
          <label className="form-label mb-2">Selecciona una categoría:</label>
          <select
            className="custom-select"
            value={category}
            onChange={handleCategoryChange}
          >
            <option value="" disabled>Selecciona una opción</option>
            <option value="inmueble">Inmueble</option>
            <option value="comercio">Comercio</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="title-counter">Último título creado: {lastTitleNumber}</label>
        </div>

        <div
          id="numerar-titulo"
          className="mb-3">
          <label className="form-label mb-2">Número de inicio de títulos:</label>
          <input
            className="form-control input-compact"
            type="number"
            min='0'
            value={titleNumberStart}
            onChange={handleNumberTitleChange}
          />
        </div>

        <div className="mb-3" id="subir-archivo-titulo">
          <label className="form-label mb-2">
            Selecciona un archivo:
          </label>

          <div className="custom-file-wrapper">
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="custom-file-input"
              id="fileUploadTitles"
            />

            <label htmlFor="fileUploadTitles" className="custom-file-button">
              Seleccionar
            </label>

            <span
              className={`custom-file-text ${!file ? "no-file" : ""}`}
            >
              {file ? file.name : "Ningún archivo seleccionado"}
            </span>
          </div>
        </div>

        <div>
          <Button
            id="generar-titulo"
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}>
            Generar Título
          </Button>
        </div>
      </div>
      <NewProcessingModal status={modalStatus} onClose={() => setModalStatus({ status: undefined, message: "" })} />
      {showTour && (
        <TittleGeneratorTour
          onFinish={() => setShowTour(false)}
        />
      )}
    </div>
  );
};

export default TitleGeneratorHome;